/* eslint-disable react/no-danger */
/* eslint-disable react-hooks/exhaustive-deps */
import * as React from 'react';
import { useIntl } from 'react-intl';
import { Control, useController } from 'react-hook-form';
import { CmdError } from '@commander-services/gui-components';
import SearchService from '../../../Services/SearchService';
import { ISimpleSelectOption } from '../ArrayFields/interfaces';

interface ISimpleSelectWithSearchProps {
  name: string;
  label: string;
  options: ISimpleSelectOption[];
  // width?: string;
  // introDisabled?: boolean;
  // hidden?: boolean;
  id: string;
  control: Control<any>;
  disabled?: boolean;
  // className?: string;
  // queueId?: string;
  introOption?: string;
  required?: boolean;
  onChangeCallback?: (value: any) => void;
  // onFocusCallback?: () => void;
  tooltip?: string;
  labelClassName?: string;
  rowClassName?: string;
  columnClassName?: string;
  note?: string;
  searchPlaceholder?: string;
  canRemoveValue?: boolean;
  selectedValueMaxWidh?: string;
}

export const getOptionByValue = (
  options: ISimpleSelectOption[],
  optionValue: string
): string | null => {
  const option = options.find(
    (item: ISimpleSelectOption) => String(item.value) === String(optionValue)
  );
  if (option) {
    return option.item;
  }
  return null;
};

export default function SimpleSelectWithSearchHookForm(props: ISimpleSelectWithSearchProps) {
  const { formatMessage: f } = useIntl();
  const {
    field: { ref, onChange, onBlur, value },
    fieldState: { invalid, error },
  } = useController({
    name: props.name,
    control: props.control,
    defaultValue: '', // or the default value
  });
  const [isOpen, setIsOpen] = React.useState<boolean>(false);
  const [optionsFromSearch, setOptionsFromSearch] = React.useState<ISimpleSelectOption[]>(
    props.options || []
  );
  const [searchString, setSearchString] = React.useState<string>('');

  React.useEffect(() => {
    if (props.options) {
      // const findValue = Object.values(props.options).find(
      //   (item) => String(item.value) === String(value)
      // );
      // if (!findValue) onChange('');
      setOptionsFromSearch(props.options);
    }
  }, [props.options]);

  const handleClickOutside = React.useCallback(
    (event: any) => {
      const { id } = event.target;

      if (id === `simpleSelect-${props.name}` || id === `selectSearch-${props.name}`) {
        // setIsOpen(true);
      } else {
        setIsOpen(false);
      }
    },
    [isOpen]
  );

  const handleEscapeKey = React.useCallback(
    (event: KeyboardEvent) => {
      if (event.key === 'Escape') {
        if (isOpen) {
          setIsOpen(false);
        }
      }
    },
    [isOpen]
  );

  React.useEffect(() => {
    window.addEventListener('click', handleClickOutside);
    window.addEventListener('keydown', handleEscapeKey);
    return () => {
      window.removeEventListener('click', handleClickOutside);
      window.removeEventListener('keydown', handleEscapeKey);
    };
  }, [handleClickOutside]);

  const handleOnChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
    const { value: evenValue } = event.currentTarget;
    onChange(evenValue);
    if (props.onChangeCallback) {
      props.onChangeCallback(evenValue);
    }
  };

  let errBorder = '';
  if (error) {
    errBorder = 'err-border';
  }

  const handleOpen = (
    event:
      | React.MouseEvent<HTMLDivElement, MouseEvent>
      | React.MouseEvent<HTMLLabelElement, MouseEvent>
  ): boolean => {
    event.preventDefault();
    if (props.disabled) {
      return false;
    }
    setIsOpen(!isOpen);
    if (isOpen) {
      // onChange.setTouched(true);
    }
    return true;
  };

  const handleOnClick = (event: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => {
    event.preventDefault();
    const eventValue = event.currentTarget.getAttribute('data-value');
    if (eventValue) {
      onChange(eventValue);
      if (props.onChangeCallback) {
        props.onChangeCallback(eventValue);
      }
      setIsOpen(false);
    }
  };

  const handleRemoveValue = (event: React.MouseEvent<HTMLLIElement>) => {
    event.preventDefault();
    onChange('');
  };

  const handleSearch = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { value: eventValue } = event.currentTarget;

    setSearchString(eventValue);

    let filteredGroups: ISimpleSelectOption[] = [];
    if (props.options) {
      const filtered = props.options.filter(
        (option: ISimpleSelectOption) =>
          SearchService.removeAccent(option.item.toLowerCase()).includes(
            SearchService.removeAccent(eventValue.toLowerCase())
          ) ||
          (option.label &&
            SearchService.removeAccent(option.label.toLowerCase()).includes(
              SearchService.removeAccent(eventValue.toLowerCase())
            ))
      );

      if (filtered.length > 0) {
        filteredGroups = [...filtered];
      }
    }

    if (eventValue) {
      setOptionsFromSearch(filteredGroups);
    } else {
      setOptionsFromSearch(props.options);
    }
  };

  return (
    <div className={`form-group ${error && 'form-group-error'}`}>
      <div className={props.rowClassName || ''}>
        <label className={`${props.labelClassName || 'd-block form-label'}`} onClick={handleOpen}>
          {props.required && <span className="text-danger required-field-info">*</span>}
          {props.label}
          {props.note && (
            <>
              <br />
              <small dangerouslySetInnerHTML={{ __html: props.note }} />
            </>
          )}
        </label>
        <div className={props.columnClassName || 'd-block'}>
          <div className={`b-dropdown ${isOpen ? 'open' : ''}`}>
            <div
              id={`simpleSelect-${props.name}`}
              data-cy={`simpleSelect-${props.id}`}
              className={`form-control-labels ${errBorder}`}
              onClick={handleOpen}
              title={props.tooltip || ''}
              style={props.disabled ? { color: '#bbbbbb' } : {}}
            >
              <span
                className="text-truncate"
                title={
                  value && props.options
                    ? getOptionByValue(props.options, value) || ''
                    : props.introOption
                }
                style={props.selectedValueMaxWidh ? { maxWidth: '300px' } : {}}
              >
                {value &&
                props.options &&
                props.options.find(
                  (item: ISimpleSelectOption) => String(item.value) === String(value)
                )
                  ? getOptionByValue(props.options, value)
                  : props.introOption}
                {value &&
                  props.options.find(
                    (item: ISimpleSelectOption) => String(item.value) === String(value)
                  ) &&
                  props.canRemoveValue ? (
                    <i
                      className="cmd-icons cmd-icon-remove"
                      style={{
                        position: 'absolute',
                        right: '30px',
                        top: '11px',
                        fontSize: '11px ',
                      }}
                      onClick={handleRemoveValue}
                      title={f({ id: 'form.cancel' })}
                    />
                  ) : null}
              </span>
            </div>
            {isOpen && !props.disabled && (
              <div
                className="b-dropdown__content"
                style={{ maxHeight: '300px', overflowY: 'auto', overflowX: 'hidden' }}
              >
                <div className="b-dropdown__header">
                  <input
                    type="text"
                    id={`selectSearch-${props.id}`}
                    className="form-control"
                    onChange={handleSearch}
                    value={searchString}
                    placeholder={props.searchPlaceholder}
                    autoFocus={true}
                    data-cy={`group-select-search-${props.id}`}
                  />
                </div>
                <ul
                  className="b-dropdown__list simple-list"
                  style={{ maxHeight: '200px', overflow: 'auto', overflowX: 'hidden' }}
                >
                  {optionsFromSearch &&
                    Object.values(optionsFromSearch).map((option: ISimpleSelectOption) => (
                      <li key={`key-${props.name}-${option.value}`}>
                        <a
                          href="#"
                          title={option.tooltip || option.item}
                          className="item"
                          data-cy={`simpleSelect-${props.name}-${option.value}`}
                          data-value={option.value}
                          onClick={handleOnClick}
                          style={
                            String(option.value) === String(value)
                              ? {
                                  backgroundColor: '#D1E9FF',
                                }
                              : {}
                          }
                        >
                          <span className="row">
                            <span className="col pr-0 text-truncate">{option.item}</span>
                            <span className="col-auto">
                              {option.label ? `${option.label}` : ''}
                            </span>
                          </span>
                        </a>
                      </li>
                    ))}
                </ul>
              </div>
            )}
            {error && error.message && <CmdError message={error.message} />}
          </div>
        </div>
      </div>
    </div>
  );
}
